module.exports = __webpack_public_path__ + "static/media/logo_wide_black.5a481710.png";